import React, { useState } from "react";
import { Box, Card, Typography, Tooltip } from "@mui/material";
import Banner from "../../../src/assests/images/banner.png";
import { Height, WidthFull } from "@mui/icons-material";
import PaginationComponent from "./Pagination";
import countgallery from "../../../src/assests/images/count-gallery.svg";
import { useNavigate } from "react-router-dom";

import { useAlert } from "../../pages/AlertContext/AlertContext";
const BannarsCard = [
  {
    id: 1,
    image: Banner,
    uploadOn: " Uploaded on : 10th October,2024",
  },
  {
    id: 2,
    image: Banner,
    uploadOn: " Uploaded on : 10th Nov,2024",
  },
  {
    id: 3,
    image: Banner,
    uploadOn: " Uploaded on : 10th Dec,2024",
  },
  {
    id: 4,
    image: Banner,
    uploadOn: " Uploaded on : 15th Jan,2023",
  },
];
type ProductStatus = "PENDING_APPROVAL" | "APPROVED" | "REJECTED";

type BannerCardProps = {
  bannerdetails: any[];
  page: any;
  limit: any;
  setPage: (page: number) => void;
  totalPages: number;
  bannerImagesLength: string
};

const BannerCard: React.FC<BannerCardProps> = ({
  bannerdetails,
  page,
  limit,
  setPage,
  totalPages,
  bannerImagesLength
}) => {
  const { showAlert } = useAlert();
  const [bannerId1, setBannerId] = useState<number>(0);


  console.log(JSON.stringify(bannerdetails, null, 2), "Responsebannerdetails");
  console.log(
    process.env.REACT_APP_API_URL,
    "process.env.REACT_APP_API_URLprocess.env.REACT_APP_API_URL"
  );
  console.log(
    `${process.env.REACT_APP_API_URL}/uploads${bannerdetails
      .map((item) => item.image)
      .join(",")}`,
    "fffffffffffffffffffff"
  );
  const handleClick = (bannerId: number) => {
    console.log(bannerId, "bannerId clicked");
    setBannerId(bannerId);
    showAlert(`Banner with ID ${bannerId} clicked!`, "success");

    navigate(`/edit-banner/${bannerId}`);
  };


  const statusLabels: Record<ProductStatus, string> = {
    PENDING_APPROVAL: "Pending For Approval",
    APPROVED: "Approved By abc@gmail.com",
    REJECTED: "Rejected",
  };

  const statusStyles: Record<ProductStatus, { background: string; color: string }> = {
    PENDING_APPROVAL: {
      background: "#FBF3E0",
      color: "#CA8501",
    },
    APPROVED: {
      background: "#EBF7E6",
      color: "#22683E",
    },
    REJECTED: {
      background: "#FFEBEE",
      color: "#C62828",
    },
  };
  console.log(bannerImagesLength, "bannerImagesLengtheeeeeeeeeeeeeeeeee")
  const navigate = useNavigate()
  console.log(bannerId1, "bannerid1ffffffffffffffff")
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          margin: "30px 0",
          flexWrap: "wrap",
          paddingTop: "20px",
          position: "relative"
        }}
      >
        {bannerdetails.map((banCard) => {
          return (
            <Box
              key={banCard.id}
              sx={{
                width: "48%",
                marginRight: "2%",
                background: "#fff",
                boxShadow: "none",
                marginBottom: "20px",
                cursor:
                  banCard.banner_status === "APPROVED" || banCard.banner_status === "REJECTED"
                    ? "pointer"
                    : "default",
              }}

              onClick={
                banCard.banner_status === "APPROVED" || banCard.banner_status === "REJECTED"
                  ? () => handleClick(banCard.id)
                  : undefined

              }

            >
              <Card sx={{ border: "0", position: "relative", boxShadow: "none" }}>
                <Typography>
                  <img crossOrigin="anonymous" src={`${process.env.REACT_APP_API_URL}/uploads/${banCard.image}`} alt="banner" style={{ width: '100%', height: '300px',}} />

                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", padding: "6px", borderRadius: "8px", background: "rgba(0, 23, 57, 0.40)", fontSize: "14px", fontWeight: "500", color: "#FFF", position: "absolute", bottom: "15%", right: "30px", transform: "translate(50%, -50%)", }}>
                  <img src={countgallery} alt="countgallery" />
                  +{banCard.banner_images_length}
                </Box>

                {/* <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",padding: "12px"}}>
                  <Typography>Location: {banCard.banner_locations}</Typography>
                  <Typography>
                    Uploaded on : {banCard.uploadOn}
                  </Typography>
                </Box> */}


                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px" }}>
                  <Typography sx={{ color: "#494A4B", fontSize: "14px", fontWeight: "500", }}>Location:
                    <Box
                      sx={{
                        fontSize: "14px",
                        margin: "2px 0 0 10px",
                        fontWeight: 400,
                        display: "inline",
                      }}
                      component="span"
                    >
                      {(() => {
                        const locations = banCard.banner_locations?.split(",") || [];
                        const firstThree = locations.slice(0, 3).join(", ");
                        const remaining = locations.slice(3).join(", ");
                        return (
                          <>
                            {firstThree}
                            {locations.length > 3 && (
                              <Tooltip title={remaining}>
                                <Typography
                                  component="span"
                                  sx={{
                                    cursor: "pointer",
                                    marginLeft: "5px",
                                    fontSize: "14px",
                                    color: "#B90022",
                                    display: "inline",

                                  }}
                                >
                                  More + {locations.length - 3}
                                </Typography>
                              </Tooltip>
                            )}
                          </>
                        );
                      })()}
                    </Box>

                    {/* {banCard.banner_locations} */}
                  </Typography>
                  <Typography sx={{ color: "#494A4B", fontSize: "14px", fontWeight: "500", }}>
                    Uploaded on : {banCard.uploadOn}
                  </Typography>
                </Box>
                {/* {banCard.banner_status === "PENDING_APPROVAL" ? (
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "12px",
                      color: "#CA8501",
                      fontWeight: "600",
                      backgroundColor: "#FBF3E0",
                      textAlign: "center",
                      padding: "6px",
                    }}
                  >
                    {banCard.banner_status}
                  </Typography>
                ) : (
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "12px",
                      color: "#22683E",
                      fontWeight: "600",
                      backgroundColor: "#EBF7E6",
                      textAlign: "center",
                      padding: "6px",
                    }}
                  >
                    {banCard.banner_status}
                  </Typography>
                )} */}

                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                    textAlign: "center",
                    padding: "6px",

                    ...(statusStyles[banCard.banner_status as ProductStatus] || {}),
                  }}
                >
                  {statusLabels[banCard.banner_status as ProductStatus] || ""}
                </Typography>


              </Card>
            </Box>
          );
        })}
      </Box>
      <Box>
        <PaginationComponent
          page={page}
          limit={limit}
          setPage={setPage}
          totalPages={totalPages}
        />
      </Box>
    </div>
  );
};
export default BannerCard;
